<app-header [label]="'AI Admin'" [sub_label]="page_name"></app-header>

<div class="p-5 flex flex-col gap-4">

  <!-- Filters -->
  <div class="flex flex-wrap items-end gap-3">
    <div class="w-52">
      <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" [(ngModel)]="params.university_id" [options]="university_options" (ngModelChange)="on_university_change()">
      </app-select-input>
    </div>
    <div class="w-52">
      <app-select-input label="Exam Name" [(ngModel)]="params.exam_id" [options]="exam_options" (ngModelChange)="apply_filters()">
      </app-select-input>
    </div>
    <div class="w-44">
      <app-select-input label="Role" [(ngModel)]="params.role_id" [options]="role_options" (ngModelChange)="apply_filters()">
      </app-select-input>
    </div>
    <div class="ml-auto flex items-center gap-2">
      <input type="text" [(ngModel)]="params.search" (ngModelChange)="apply_filters()" placeholder="Search Name, Email..." class="border border-gray-200 rounded-lg px-4 py-2 text-sm w-64 focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30" />
    </div>
  </div>

  <!-- Grid -->
  <app-ag-grid-list [list]="items" [colDefs]="columns" [show_checkboxes]="false" [itemName]="page_name" [rowHeight]="60" (fetch_new_list)="get_list($event)">
  </app-ag-grid-list>

</div>

<!-- ═══════════════════════════════════════════════════
     AI TRIGGER VIEW MODAL
     ═══════════════════════════════════════════════════ -->
<div *ngIf="show_view_modal" class="fixed inset-0 z-40 flex items-center justify-center bg-black/50 px-4">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col max-h-[92vh] overflow-y-auto">

    <!-- Header -->
    <div class="flex items-center justify-between px-8 pt-7 pb-5">
      <h2 class="text-[17px] font-extrabold text-[#111827] tracking-widest uppercase">AI Trigger</h2>
      <button type="button" (click)="close_view()" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition">
        <svg class="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Info row -->
    <div class="grid grid-cols-4 gap-6 px-8 pb-6">
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-1">Name</p>
        <p class="text-[14px] font-bold text-[#111827]">{{ selected_log?.User?.name || '—' }}</p>
      </div>
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-1">User ID</p>
        <p class="text-[14px] font-bold text-[#111827] break-all">{{ selected_log?.User?.email || '—' }}</p>
      </div>
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-1">Captured Date &amp; Time</p>
        <p class="text-[14px] font-bold text-[#111827]">{{ format_date(selected_log?.captured_at) }}</p>
      </div>
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-1">AI Trigger</p>
        <p class="text-[14px] font-bold flex items-center gap-1.5" [style.color]="trigger_color">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" [attr.xmlns]="'http://www.w3.org/2000/svg'">
            <path d="M12 2L1 21h22L12 2z" [attr.fill]="trigger_color" opacity="0.15"/>
            <path d="M12 2L1 21h22L12 2z" [attr.stroke]="trigger_color" stroke-width="2" stroke-linejoin="round"/>
            <line x1="12" y1="10" x2="12" y2="14" [attr.stroke]="trigger_color" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="17.5" r="1" [attr.fill]="trigger_color"/>
          </svg>
          {{ trigger_label }}
        </p>
      </div>
    </div>

    <!-- Photos section -->
    <div class="px-8 pb-8">

      <!-- Two photos (face_not_matched or login_rejected) -->
      <div *ngIf="show_two_photos" class="grid grid-cols-2 gap-5">
        <div>
          <p *ngIf="show_labels_on_photos" class="text-[13px] text-[#9CA3AF] mb-2">Original</p>
          <div class="rounded-xl overflow-hidden border border-gray-200 bg-gray-50 aspect-[4/3] flex items-center justify-center">
            <img *ngIf="selected_log?.registered_image" [src]="selected_log.registered_image" alt="Registered Photo" class="w-full h-full object-cover" />
            <div *ngIf="!selected_log?.registered_image" class="flex flex-col items-center gap-2">
              <svg class="w-10 h-10 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <p class="text-[12px] text-gray-400">No photo</p>
            </div>
          </div>
        </div>
        <div>
          <p *ngIf="show_labels_on_photos" class="text-[13px] text-[#9CA3AF] mb-2">Captured</p>
          <div class="rounded-xl overflow-hidden border border-gray-200 bg-gray-50 aspect-[4/3] flex items-center justify-center">
            <img *ngIf="selected_log?.captured_image" [src]="selected_log.captured_image" alt="Captured Photo" class="w-full h-full object-cover" />
            <div *ngIf="!selected_log?.captured_image" class="flex flex-col items-center gap-2">
              <svg class="w-10 h-10 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <p class="text-[12px] text-gray-400">No photo</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Single photo (no_face_detected) -->
      <div *ngIf="!show_two_photos">
        <div class="rounded-xl overflow-hidden border border-gray-200 bg-gray-50 max-h-[420px] flex items-center justify-center">
          <img *ngIf="selected_log?.captured_image" [src]="selected_log.captured_image" alt="Captured Photo" class="w-full object-cover max-h-[420px]" />
          <div *ngIf="!selected_log?.captured_image" class="flex flex-col items-center gap-2 py-16">
            <svg class="w-14 h-14 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <p class="text-[13px] text-gray-400">No photo available</p>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
